import React from "react";

export const GreenPlusCircle = () => {
  return (
    <svg width={18} height={19} viewBox="0 0 18 19" fill="none">
      <circle
        cx={9}
        cy={9.27295}
        r={8}
        stroke="#1EA686"
        strokeWidth={2}
        fill="white"
      />
      <line
        x1={9}
        y1={5.27295}
        x2={9}
        y2={13.2729}
        stroke="#1EA686"
        strokeWidth={2}
      />
      <line
        x1={13}
        y1={9.27295}
        x2={5}
        y2={9.27295}
        stroke="#1EA686"
        strokeWidth={2}
      />
    </svg>
  );
};
